"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  camelCase: true,
  capitalize: true,
  kebabCase: true,
  lowerCase: true,
  lowerFirst: true,
  snakeCase: true,
  startCase: true,
  template: true,
  toLower: true,
  toUpper: true,
  trimStart: true,
  upperFirst: true
};
Object.defineProperty(exports, "camelCase", {
  enumerable: true,
  get: function get() {
    return _lodash.camelCase;
  }
});
Object.defineProperty(exports, "capitalize", {
  enumerable: true,
  get: function get() {
    return _lodash.capitalize;
  }
});
Object.defineProperty(exports, "kebabCase", {
  enumerable: true,
  get: function get() {
    return _lodash.kebabCase;
  }
});
Object.defineProperty(exports, "lowerCase", {
  enumerable: true,
  get: function get() {
    return _lodash.lowerCase;
  }
});
Object.defineProperty(exports, "lowerFirst", {
  enumerable: true,
  get: function get() {
    return _lodash.lowerFirst;
  }
});
Object.defineProperty(exports, "snakeCase", {
  enumerable: true,
  get: function get() {
    return _lodash.snakeCase;
  }
});
Object.defineProperty(exports, "startCase", {
  enumerable: true,
  get: function get() {
    return _lodash.startCase;
  }
});
Object.defineProperty(exports, "template", {
  enumerable: true,
  get: function get() {
    return _lodash.template;
  }
});
Object.defineProperty(exports, "toLower", {
  enumerable: true,
  get: function get() {
    return _lodash.toLower;
  }
});
Object.defineProperty(exports, "toUpper", {
  enumerable: true,
  get: function get() {
    return _lodash.toUpper;
  }
});
Object.defineProperty(exports, "trimStart", {
  enumerable: true,
  get: function get() {
    return _lodash.trimStart;
  }
});
Object.defineProperty(exports, "upperFirst", {
  enumerable: true,
  get: function get() {
    return _lodash.upperFirst;
  }
});

var _inflect = require("./inflect");

Object.keys(_inflect).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _inflect[key];
    }
  });
});

var _lodash = require("lodash");